import React from 'react';
import classes from 'components/common/PageContainer/actionsSection.module.scss';

interface Props {
    children: React.ReactNode;
}

export const ActionsSection = ({ children }: Props) => {
    return <div className={classes.topSectionActions}>{children}</div>;
};
